import { render, staticRenderFns } from "./TipoAccionesDisciplinarias.vue?vue&type=template&id=50521a58&scoped=true"
import script from "./TipoAccionesDisciplinarias.vue?vue&type=script&lang=js"
export * from "./TipoAccionesDisciplinarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50521a58",
  null
  
)

export default component.exports